import React from "react";
import { Button } from "@mantine/core";
import cx from "clsx";

const DefaultButton = ({ className, text, ...props }) => {
  return (
    <Button className={cx(className, "default-btn")} {...props}>
      {text}
    </Button>
  );
};

export default DefaultButton;
